import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DoubleArrow, Check } from '@mui/icons-material';
import { popOver } from '../../assets/templates';
import ToggleButton from '../ui/ToggleButton';
import validateRequiredFields, { toInteger } from '../../utilities';

const SelectPriceView = ({
  view,
  setView,
  calculationsData,
  setCalculationsData,
}) => {
  const [isNextStepAvailable, setIsNextStepAvailable] = useState(false);
  const [validateSubmit, setValidateSubmit] = useState(false);

  useEffect(() => {
    if (calculationsData.price?.isPriceDefinedByUtility) {
      const totalCost = Number((calculationsData.design.costPerDesign + calculationsData.worker.productionCostPerDesign
      + calculationsData.electricity.electricityCostPerDesign).toFixed(2));
      const profitInCurrency = toInteger((totalCost * ((calculationsData.price.profitInPercentage / 100) + 1)), 2)
      - totalCost;

      setCalculationsData({
        ...calculationsData,
        price: {
          ...calculationsData.price,
          designFullCost: totalCost,
          profitInCurrency: profitInCurrency > 0 ? profitInCurrency : 0,
          salePricePerDesign: profitInCurrency + totalCost,
        },
      });
      if (isNextStepAvailable) return;
      setIsNextStepAvailable(true);
    } else if (!calculationsData.price?.isPriceDefinedByUtility) {
      const totalCost = Number((calculationsData.design.costPerDesign + calculationsData.worker.productionCostPerDesign
      + calculationsData.electricity.electricityCostPerDesign).toFixed(2));
      const profitInCurrency = toInteger((calculationsData.price?.salePricePerDesign || 0) - totalCost, 2);

      setCalculationsData({
        ...calculationsData,
        price: {
          ...calculationsData.price,
          designFullCost: totalCost,
          profitInCurrency: profitInCurrency > 0 ? profitInCurrency : 0,
          profitInPercentage:
            ((calculationsData.price?.salePricePerDesign || 0) / (totalCost * 100)) - 100 <= 0
              ? 0 : toInteger(((calculationsData.price?.salePricePerDesign || 0) / (totalCost * 100)) - 100, 2),
        },
      });

      if (isNextStepAvailable) return;
      setIsNextStepAvailable(true);
    }
  }, [calculationsData?.price?.salePricePerDesign,
    calculationsData?.price?.profitInPercentage]);

  useEffect(() => {
    setValidateSubmit(validateRequiredFields(document.querySelectorAll('[required]')));
  }, [calculationsData.price]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        setView(view + 1);
      }}
      className="main-container"
      style={{ position: 'relative' }}
    >

      <button
        onClick={() => setView(view - 1)}
        id="button"
        className="simple-button"
        type="button"
        style={{ position: 'absolute', top: '0', left: '0' }}
      >
        <DoubleArrow sx={{ transform: 'rotate(180deg)' }} />
        Paso anterior
      </button>

      {isNextStepAvailable && typeof calculationsData?.price?.isPriceDefinedByUtility === 'boolean'
      && (
        <button
          id="button"
          className="simple-button"
          type="submit"
          data-available={validateSubmit}
          data-disabled={!validateSubmit}
          style={{ position: 'absolute', top: '0', right: '0' }}
        >
          <DoubleArrow />
          Resultados
        </button>
      )}

      <div style={{ maxWidth: '600px', margin: '50px auto 30px auto' }} className="appear aligned-items justify-items">
        <ToggleButton
          value={calculationsData?.price?.isPriceDefinedByUtility === false}
          setValue={() => setCalculationsData({
            ...calculationsData,
            price: {
              ...calculationsData.price,
              isPriceDefinedByUtility: false,
            },
          })}
          style={{ marginRight: '50px' }}
          textLabel={`Asignar precio fijo al producto (${calculationsData.currentCurrency.symbol})`}
        />
        <ToggleButton
          value={calculationsData?.price?.isPriceDefinedByUtility === true}
          setValue={() => setCalculationsData({
            ...calculationsData,
            price: {
              ...calculationsData.price,
              isPriceDefinedByUtility: true,
            },
          })}
          textLabel="Asignar utilidad al producto (%)"
        />
      </div>

      {calculationsData?.price?.isPriceDefinedByUtility === false
      && (
      <div className="appear item-container icon-wrapper">
        <p style={{ margin: '0' }}>
          {(calculationsData?.worker?.employeeSalaryPerMonth > 0)
            && (<Check className="appear" sx={{ color: 'green', fontSize: '15px' }} />)}
          Precio a público del producto/diseño (
          {calculationsData.currentCurrency.currencyCode}
          )
        </p>
        <div data-title={popOver[6]}>
          <img
            alt="icon"
            src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
          />
        </div>
        <div style={{ position: 'relative', width: '100%' }}>
          <input
            placeholder="250"
            style={{ padding: '3px 80px 3px 25px' }}
            className="select"
            type="number"
            required
            step="0.01"
            value={calculationsData?.price?.salePricePerDesign || ''}
            onChange={(e) => setCalculationsData({
              ...calculationsData,
              price: {
                ...calculationsData.price,
                salePricePerDesign: Number(e.target.value),
              },
            })}
          />
          <p className="start-input-icon">{calculationsData.currentCurrency.symbol}</p>
        </div>
      </div>
      )}

      {calculationsData?.price?.isPriceDefinedByUtility
      && (
      <div className="appear item-container icon-wrapper">
        <p style={{ margin: '0' }}>
          {(calculationsData?.worker?.employeeSalaryPerMonth > 0)
            && (<Check className="appear" sx={{ color: 'green', fontSize: '15px' }} />)}
          Porcentaje de utilidad esperado (%)
        </p>
        <div data-title={popOver[36]}>
          <img
            alt="icon"
            src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
          />
        </div>
        <div style={{ position: 'relative', width: '100%' }}>
          <input
            placeholder="50"
            style={{ padding: '3px 80px 3px 25px' }}
            className="select"
            type="number"
            required
            step="0.01"
            value={calculationsData?.price?.profitInPercentage || ''}
            onChange={(e) => setCalculationsData({
              ...calculationsData,
              price: {
                ...calculationsData.price,
                profitInPercentage: Number(e.target.value),
              },
            })}
          />
          <p className="end-input-icon">%</p>
        </div>

        <p style={{ margin: '20px 0 0 0' }}>Precio de venta que tendra su producto</p>
        <div style={{ display: 'contents' }} data-title={popOver[38]}>
          <img
            alt="icon"
            src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
          />
        </div>
        <div style={{ position: 'relative', width: '100%' }}>
          <input
            placeholder="60"
            style={{ padding: '3px 20px 3px 25px' }}
            className="select"
            type="number"
            disabled
            readOnly
            value={toInteger(calculationsData?.price?.salePricePerDesign, 2)}
          />
          <p className="start-input-icon">{calculationsData.currentCurrency.symbol}</p>
        </div>
      </div>
      )}

      {(calculationsData.price?.designFullCost >= 0 && calculationsData?.price?.profitInCurrency >= 0
      && typeof calculationsData.price?.isPriceDefinedByUtility === 'boolean')
      && (
      <div style={{ display: 'flex' }} className="appear item-container-contrast icon-wrapper price-results-container">
        <div style={{ marginRight: '100px' }}>
          <p style={{ margin: '0' }}>Costo total por diseño</p>
          <div style={{ display: 'contents' }} data-title={popOver[38]}>
            <img
              alt="icon"
              src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
            />
          </div>
          <div style={{ position: 'relative', width: '100%' }}>
            <input
              placeholder="60"
              style={{ padding: '3px 20px 3px 25px' }}
              className="select"
              type="number"
              disabled
              readOnly
              value={calculationsData?.price?.designFullCost.toFixed(2)}
            />
            <p className="start-input-icon">{calculationsData.currentCurrency.symbol}</p>
          </div>
        </div>
        <div>
          <p style={{ margin: '0' }}>
            {(calculationsData?.price?.profitInCurrency > 0)
            && (<Check className="appear" sx={{ color: 'green', fontSize: '15px' }} />)}
            Utilidad por diseño
          </p>
          <div style={{ display: 'contents' }} data-title={popOver[9]}>
            <img
              alt="icon"
              src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
            />
          </div>
          <div style={{ position: 'relative', width: '100%' }}>
            <input
              placeholder="0"
              style={{ padding: '3px 20px 3px 25px', backgroundColor: '#d6d6d6' }}
              className="select"
              type="number"
              required
              step="0.01"
              data-disabled
              onInvalid={(e) => {
                if (!e.target.value) {
                  e.target.setCustomValidity('la utilidad debe de ser mayor a 0');
                } else {
                  e.target.setCustomValidity('');
                }
              }}
              value={calculationsData?.price?.profitInCurrency <= 0
                ? '' : calculationsData?.price?.profitInCurrency.toFixed(2)}
              onChange={() => {}}
            />
            <p className="start-input-icon">{calculationsData.currentCurrency.symbol}</p>
          </div>
        </div>
      </div>
      )}

    </form>
  );
};

SelectPriceView.propTypes = {
  view: PropTypes.number.isRequired,
  setView: PropTypes.func.isRequired,
  calculationsData: PropTypes.shape({
    currentCurrency: PropTypes.shape({
      currency: PropTypes.string,
      currencyCode: PropTypes.string,
      country: PropTypes.string,
      symbol: PropTypes.string,
    }),
    price: PropTypes.shape({
      designFullCost: PropTypes.number,
      isPriceDefinedByUtility: PropTypes.bool,
      profitInCurrency: PropTypes.number,
      profitInPercentage: PropTypes.number,
      salePricePerDesign: PropTypes.number,
    }),
    electricity: PropTypes.shape({
      electricityCostPerDesign: PropTypes.number,
    }),
    worker: PropTypes.shape({
      productionCostPerDesign: PropTypes.number,
      employeeSalaryPerMonth: PropTypes.number,
    }),
    design: PropTypes.shape({
      costPerDesign: PropTypes.number,
    }),
  }).isRequired,
  setCalculationsData: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => (
  {
    view: state.view,
    calculationsData: state.calculationsData,
  });

const mapDispatchToProps = (dispatch) => ({
  setView: (values) => dispatch({
    type: 'SET_VIEW',
    payload: values,
  }),
  setCalculationsData: (values) => dispatch({
    type: 'SET_CALCULATIONS_DATA',
    payload: values,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectPriceView);
